<template>
	<div class="stepOut">
		<ul class="stepul">
			<li class="stepItem" v-for="(stepItem, index) in stepInfo.list" :key="index">
				<!-- 模拟步骤条的节点，此处为圆圈 -->
				<div :class="stepInfo.step >= index+1 ? 'icon active':'icon'"></div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'steps',
		props: {
			// 传递步骤参数
			stepInfo: {
				type: Object,
				default: function() {
					return {
						list: [],
						step: 0
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.stepul {
		margin: 0px;
		padding: 15px 0px;
	}

	.stepOut {
		width: 100%;
		display: flex;
		justify-content: center;

		.stepItem {
			width: 18px;
			float: left;
			font-family: SimSun;
			font-size: 16px;
            border-color: #9B9B9B transparent;
            margin-right: 3px;
			.icon {
				background: rgba(226, 226, 226, 1);
				margin: 0 auto;
				position: relative;
				z-index: 888;
				border-top: 4px solid transparent;
				border-bottom: 4px solid transparent;
			}

			.active {
				background-color: #005dbe;
			}

			.line {
				position: absolute;
				top: 6px;
				left: 50%;
				border-bottom: 1px dashed rgba(3, 2, 2, 0.7);
				width: 260px;
				z-index: 111;
			}

			.lineActive {
				border-bottom: 1px solid green;
			}

			.stepStatus {
				color: rgba(87, 87, 87, 1);
				line-height: 36px;
			}

			.statusTime {
				color: rgba(87, 87, 87, 1);
				opacity: 0.5;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/step.vue